//能耗类型
export const energyDataType = {
  temperature: 1,
  humidity: 2,
  electricity: 3,
  gas: 4,
  co2: 5,
  formaldehyde: 6,
  waterYield: 7,
  heaterConsumptionGasRate: 8,//表示热水系统中平均每升水耗气量
};
//电量系统类型
export const energySystemType = {
  allElectricity: 0, //总电量
  airElectricity: 1, //空调系统电量
  freshAirElectricity: 2, //新风系统电量
  purificationWaterElectricity: 3, //净水电量
  lampElectricity: 4, //灯光电量
  hotWaterElectricity: 5, //热水系统
  socketElectricity: 6, //插座电量
  centerPurificationWater: 8, //中央净水量
  softWater: 9, //软水量
  pureWater: 10, //纯水量
};
//时间类型
export const dateType = {
  hourType: 1,
  dayType: 2,
  monthType: 3,
  yearType: 4
};
//判断设备类型
export const getEnergyType = {
  getType: function (systemType, energyType) {
    var energytypeName = "";
    var systemTypeName = "";
    switch (energyType) {
      case energyDataType.electricity:
        energytypeName = "电量";
        break;
      case energyDataType.waterYield:
        energytypeName = "水量";
        break;
      case energyDataType.gas:
        energytypeName = "气量";
        break;
    }
    switch (systemType) {
      case energySystemType.allElectricity:
        systemTypeName = '总耗';
        break;
      case energySystemType.airElectricity:
        systemTypeName = '空调';
        break;
      case energySystemType.freshAirElectricity:
        systemTypeName = '新风';
        break;
      case energySystemType.purificationWaterElectricity:
        systemTypeName = '净水';
        break;
      case energySystemType.lampElectricity:
        systemTypeName = '灯光';
        break;
      case energySystemType.hotWaterElectricity:
        systemTypeName = '热水';
        break;
      case energySystemType.socketElectricity:
        systemTypeName = '插座';
        break;
      case energySystemType.centerPurificationWater:
        systemTypeName = '中央净水量';
        break;
      case energySystemType.softWater:
        systemTypeName = '软水';
        break;
      case energySystemType.pureWater:
        systemTypeName = '纯水';
        break;
      default:
        break;
    }
    return systemTypeName + energytypeName;
  }
}



// WEBPACK FOOTER //
// ./src/utils/typeParam.js